import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Give me your guestpost and I will give you my love!",
  "description": "",
  "published": "2012-06-20T00:00:00.000Z",
  "redirect_from": ["/blog/give-me-your-guestpost-and-i-will-give-you-my-love/swizec/4691"],
  "categories": "blog, Radio silence, RSS, Uncategorized",
  "hero": "./img/NeGxI.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "480px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/e85cb/NeGxI.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "166.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'667\\'%20viewBox=\\'0%200%20400%20667\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20100v100l11%201a146%20146%200%200053-5l9-1c5-2%2015-1%2032%201a84%2084%200%200025%200c3%200%207-5%207-7%200-4%203-5%2010-5%208%200%2017-2%2016-4l-1-6c-1-6-1-6%2011-7%2011%200%2011%200%2015%206%202%203%208%205%2022%206%2012%200%2014%200%2014-5%200-8-1-8%2060-7%2048%200%2055%200%2072%203%209%202%2010%203%206%206l-2%203a138%20138%200%200025%207l1%201%201%201%202%201%203%201h1l6%202%201%204%201-96V0H0v100m174%20200l2%202%201%202-4-2c0-1-1-2-3-2s-3%201-3%202l-1%201c-3-1-7%2013-4%2016v3c0%202%202%204%204%204l3%202c1%201%201%201%201-2l-1-4%203%201%205%201%203%201h1c-2-5-2-6-1-6%203%201%202%200%200-5-2-4-2-5%201-3h2l1%201c1%201%201%200%201-3-1-5%200-5%202-1%202%202%202%202%203%201%200-2-1-5-3-5l-2-2c-2-2-2-2-4-1-2%202-2%202-3%200%200-2%200-2-1-1h-1l-1-2-1%202m118%2013l-11%205%202%201h4c2%200%202%200%200%202l-4%203c-5%202-10%208-8%209h4l1%201-1%202c-2%201%200%204%202%204l1%201%204%201c3%200%205%203%203%204v1l-2%202-3%203h2c2%201%204%206%202%208l-1%202-1%202c-1%201-2%203-1%205%200%203%201%203%204%203%204%200%205-1%204-3l1-1%201%201%201%201v-2c0-3%200-3%202-3s2%200%201-1v-1h1v-1l2-1c3%200%206-3%206-5l2-2%201-5%203-11%203-10c0-6-6-13-12-13l-3-1c-1-1-7-2-10-1m-114%2030l-1%202c-2-1-7%202-8%204v9a856%20856%200%20012%208l3-4%205-5%201-2c1%200%203-5%203-8%200-5-3-8-5-4m61%208l-1%201c-1%200-2%201-2%203l-2%202c0-2-2%201-2%203h1v3c-1%205-2%206-2%202s0-5-4-3c-3%202-3%202-2%200%200-2%200-2-2-1l-6%203c-3%201-4%202-4%204l1%203%201%202c0%201-2%202-4%200l-17-8c-17-2-28%2023-16%2035%202%202%204%204%203%205l7%2010c4%203%2012%204%2014%201h2l2-2%203-1%206%201%205%201c1%202%204%202%204%200%201-2%201-2%203-1h8c1-2%200-5-1-5-2%200-4-3-3-3l1-3%202-2%202-1c1-1%201-1%200%200l1%202%202-3%201-1%201-3v-5l1-4c0-3%202-4%205-3h4l3%203c2%204%204%205%207%205s2-2%200-3c-3-1-3-1-2-5v-22c-2-4-6-8-9-9l-4-1h-7m-7%2018c-2%203-2%204-1%204l1%202c0%202%200%202%202%202h1l-1%201-1%201%201%202h1c-2%201-1%202%201%202l3%201h1l1-2%202-1c1-1%201-1-1-3l-2-4-2-4-2-2-1-1-3%202M0%20583v84h401v-85c0-46%200-84-1-83s-337%202-383%201l-17-1v84m0%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/ca0a1/NeGxI.webp 223w", "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/75680/NeGxI.webp 445w", "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/d3be9/NeGxI.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/e92b6/NeGxI.png 223w", "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/e66bf/NeGxI.png 445w", "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/e85cb/NeGxI.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cdfaf1dd0ea9b1f307b8587728a9d7cd/e85cb/NeGxI.png",
                "alt": "A cute hedgehog",
                "title": "A cute hedgehog",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`A cute hedgehog`}</figcaption>{`
  `}</figure></p>
    <p>{`Next week is going to be rather busy. Three (possibly four) exams and giving a short talk ... that needs to be prepared, delivered and the resulting lady fans wooed.`}</p>
    <p>{`You know how it goes.`}</p>
    <p>{`I don't want to go into radio silence for a whole week. Writing crappy quickies all week is severely undesirable as well.`}</p>
    <p>{`SO,`}</p>
    <p>{`if you've got `}<em parentName="p">{`anything`}</em>{` to say, anything at all, say it here.`}</p>
    <p>{`Write a guest post for this site on anything ranging from science, to tea and the startup world. I'm not particularly picky, but I want to feel a human voice (as opposed to a generic marketing post spam)`}</p>
    <p>{`Why would you do that? Because:`}</p>
    <ol>
      <li parentName="ol">{`You shall win my eternal gratitude. I will owe you `}<strong parentName="li">{`two`}</strong>{` not one (favour, blogpost, whatever)`}</li>
      <li parentName="ol">{`Your post will land in ~800 adoring RSS readers`}</li>
      <li parentName="ol">{`I'm going to tweet your post exactly three times. That gets a reader or two`}</li>
      <li parentName="ol">{`I will lovingly spoon feed your post to all 1700 of my G+ humans`}</li>
      <li parentName="ol">{`Did I mention I'm going to love you forever?`}</li>
    </ol>
    <p>{`If that isn't enough to convince you, I have attached a cute hedgehog. You can't say no to something `}<em parentName="p">{`that`}</em>{` cute. Fact.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=52e52a66-a751-4359-8e0c-782dedbbe282",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      